<template>

    <div class="d-flex flex-column align-items-center justify-content-center text-center py-5 px-3" style="min-height: 100%">
        <div class="rule" style="margin-bottom: 4rem;">
            <div class="d-flex align-items-center justify-content-center mb-2"><span class="number">1.</span> pravilo:</div>
            <router-link :to="firstRuleUrl" :class="['rule-title', {'active': this.$route.path === firstRuleUrl}]" @click.native="makeWebpageScrollable">Naredi backup!</router-link>
        </div>
        <div class="rule" style="margin-bottom: 4rem;">
            <div class="d-flex align-items-center justify-content-center  mb-2"><span class="number">2.</span> pravilo:</div>
            <router-link :to="secondRuleUrl" :class="['rule-title', {'active': this.$route.path === secondRuleUrl}]" @click.native="makeWebpageScrollable">Ne verjemi velikim obljubam!</router-link>
        </div>
        <div class="rule">
            <div class="d-flex align-items-center justify-content-center  mb-2"><span class="number">3.</span> pravilo:</div>
            <router-link :to="thirdRuleUrl" :class="['rule-title', {'active': this.$route.path === thirdRuleUrl}]" @click.native="makeWebpageScrollable">Za profilno sliko je lahko kdorkoli!</router-link>
        </div>
    </div>
</template>

<script>
	export default {
		name: "HamburgerMenu",
		data() {
			return {
				firstRuleUrl: `/${process.env.VUE_APP_FIRST_RULE_URL}`,
				secondRuleUrl: `/${process.env.VUE_APP_SECOND_RULE_URL}`,
				thirdRuleUrl: `/${process.env.VUE_APP_THIRD_RULE_URL}`,
			}
		},
        methods: {
			makeWebpageScrollable() {
				document.documentElement.classList.remove('overflow-hidden');
				document.body.classList.remove('overflow-hidden');
            },
        },
	}
</script>

<style lang="scss" scoped>
    .rule {
        font-size: 1.5rem;
        line-height: 1;

        .number {
            $size: 35px;

            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: $size;
            height: $size;
            margin-right: 10px;
            border-radius: 50%;
            background: #000;
            color: #fff;
        }

        .rule-title {
            color: #000;
            text-transform: uppercase;
            text-decoration: none;
            font-size: 2.2rem;

            &.active {
                font-weight: bold;
                text-decoration: underline;
            }

            &:hover {
                text-decoration: underline;
            }
        }
    }
</style>